export namespace FormatUtilities {
  export const getCourseNumberAsLevel = function (courseNumber: number): string {
    if (courseNumber == null) return "L0";

    // TODO: Standardize these special cases so they don't need to be special
    if (courseNumber == 0) return "Placement Test";
    if (courseNumber == 8) return "Older Beginner";
    if (courseNumber == 10) return "Pathways"

    return `L${courseNumber}`;
  }

  export const displayTime = function (sec: number): string {
    if (!sec)
      return '0:0:0';
    const normalizeTime = (time: string): string => (time.length === 1) ? time.padStart(2, '0') : time;

    let seconds: string = (sec).toFixed(0);
    let minutes: string = Math.floor(parseInt(seconds) / 60).toString();
    let hours: string = '';

    if (parseInt(minutes) > 59) {
      hours = Math.floor(parseInt(minutes) / 60).toString();
      minutes = normalizeTime((parseInt(minutes) - (parseInt(hours) * 60)).toString());
    }
    seconds = normalizeTime(Math.floor(parseInt(seconds) % 60).toString());

    return (hours !== '') ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
  }

  export const displayTimeWithoutSeconds = function (sec: number): string {
    if (!sec)
      return '0 min';
    const normalizeTime = (time: string): string => (time.length === 1) ? time.padStart(2, '0') : time;

    let seconds: string = (sec).toFixed(0);
    let minutes: string = Math.ceil(parseInt(seconds) / 60).toString();
    let hours: string = ""

    if (parseInt(minutes) > 59) {
      hours = Math.floor(parseInt(minutes) / 60).toString();
      minutes = normalizeTime((parseInt(minutes) - (parseInt(hours) * 60)).toString());
    }

    return (hours !== '') ? `${hours + " hr "}${minutes + " min"}` : `${minutes + " min"}`;
  }

  export const displaySkill = function (skillType: string, skillConcept: string): string {
    return skillType === 'Phonics_Letters_Identify'
      ? skillConcept.replace(/upper_|lower_/g, '')
      : displaySkillConcept(skillConcept);
  }

  export const displaySkillConcept = function (skillConcept: string): string {
    return skillConcept.replace(/_/g, ' ').replace(/\bi\b/g, 'I').replace(/\bcant\b/g, "can't").replace(/\bdont\b/g, "don't").replace(/\bwhats\b/g, "what's").replace(/\bits\b/g, "it's")
  }

  export const monthNames = [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun", "Jul",
    "Aug", "Sep", "Oct",
    "Nov", "Dec"
  ];

  export const longDateFormat = function (date: string) {
    var dateToFormat = new Date(date);
    var day = dateToFormat.getDate();
    var monthIndex = dateToFormat.getMonth();
    var year = dateToFormat.getFullYear();
  
    return `${monthNames[monthIndex]} ${day}, ${year}`;
  }

  export const longDateFormatUtc = function (date: string) {
    var dateToFormat = new Date(date);
    var day = dateToFormat.getUTCDate();
    var monthIndex = dateToFormat.getUTCMonth();
    var year = dateToFormat.getUTCFullYear();
  
    return `${monthNames[monthIndex]} ${day} ${year}`;
  }

  export const dateDelta = function (attemptedDate: string) {
    var today = new Date;
    var createdOnDate = new Date(attemptedDate);
    var dayDifference = Math.floor((today.getTime() - createdOnDate.getTime()) / (1000 * 3600 * 24));
    var monthDifference = today.getMonth() - createdOnDate.getMonth();

    if (dayDifference > 30) {
      return monthDifference === 1 ? monthDifference + " month ago" : monthDifference + " months ago";
    } else {
      return dayDifference === 1 ? dayDifference + " day ago" : dayDifference + " days ago"
    }
  }
}
